import { useLayoutEffect, useRef } from 'react'
import { Outlet, useLocation, useNavigationType } from 'react-router-dom'
import { useReveal } from '../lib/motion.ts'
import { scrollToTop } from '../lib/scroll.ts'
import { TabBar } from './TabBar.tsx'

/**
 * Page key for the enter animation: the first two path segments, so steps inside one screen (/ayat/3/iqra →
 * /ayat/3/fahami, a challenge day) do not replay it, while another surah or card does.
 */
const pageKey = (path: string) => path.split('/').slice(0, 3).join('/')

/** Authenticated layout: content + tab bar (sidebar on desktop). Focus screens render outside of it. */
export function Shell() {
  const { pathname } = useLocation()
  const nav = useNavigationType()
  const main = useRef<HTMLElement>(null)
  useReveal(main)

  // A new page starts at the top; Back keeps the browser's position.
  useLayoutEffect(() => {
    if (nav !== 'POP') scrollToTop()
  }, [pathname]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="app">
      <TabBar />
      <main className="view" id="main" ref={main}>
        <div className="route" key={pageKey(pathname)}>
          <Outlet />
        </div>
      </main>
    </div>
  )
}
